export default __webpack_public_path__ + "static/media/SenseOfPurpose5.3a2bd805.png";